import React from "react";
import TextField from "Components/UI/TextField";
import { Typography } from "@mui/material";

export default function EmailSubscription({
  client,
  handleInputChange,
  loading,
  FORM_MODE,
}) {
  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "1rem",
          paddingBottom: "4rem",
        }}
      >
        <TextField
          name="Report_Payment_Subscription"
          disabled={FORM_MODE === "LOCKED"}
          label="Inbetalning"
          value={client?.Report_Payment_Subscription}
          onChange={(e) =>
            handleInputChange("Report_Payment_Subscription", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />

        <TextField
          name="Report_Collection_Subscription"
          disabled={FORM_MODE === "LOCKED"}
          label="Inkasso"
          value={client?.Report_Collection_Subscription}
          onChange={(e) =>
            handleInputChange("Report_Collection_Subscription", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />

        <TextField
          name="Report_Settlement_Subscription"
          disabled={FORM_MODE === "LOCKED"}
          label="Avräkning"
          value={client?.Report_Settlement_Subscription}
          onChange={(e) =>
            handleInputChange("Report_Settlement_Subscription", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />

        <TextField
          name="Report_Payout_Subscription"
          disabled={FORM_MODE === "LOCKED"}
          label="Utbetalning"
          value={client?.Report_Payout_Subscription}
          onChange={(e) =>
            handleInputChange("Report_Payout_Subscription", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />

        <TextField
          name="Report_Engagement_Subscription"
          disabled={FORM_MODE === "LOCKED"}
          label="Engagemang"
          value={client?.Report_Engagement_Subscription}
          onChange={(e) =>
            handleInputChange("Report_Engagement_Subscription", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />
      </div>
      <Typography variant="subtitle2">BgMax</Typography>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "1rem",
          marginTop: "1rem",
        }}
      >
        <TextField
          name="FortnoxEmailBgmaxPurchase"
          disabled={FORM_MODE === "LOCKED"}
          label="BgMax Köp"
          value={client?.FortnoxEmailBgmaxPurchase}
          onChange={(e) =>
            handleInputChange("FortnoxEmailBgmaxPurchase", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="FortnoxEmailBgmaxPurchaseDenied"
          disabled={FORM_MODE === "LOCKED"}
          label="BgMax Köp Nekad"
          value={client?.FortnoxEmailBgmaxPurchaseDenied}
          onChange={(e) =>
            handleInputChange("FortnoxEmailBgmaxPurchaseDenied", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="FortnoxEmailBgmaxService"
          disabled={FORM_MODE === "LOCKED"}
          label="BgMax Service"
          value={client?.FortnoxEmailBgmaxService}
          onChange={(e) =>
            handleInputChange("FortnoxEmailBgmaxService", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="FortnoxEmailBgmaxServiceDenied"
          disabled={FORM_MODE === "LOCKED"}
          label="BgMax Service Nekad"
          value={client?.FortnoxEmailBgmaxServiceDenied}
          onChange={(e) =>
            handleInputChange("FortnoxEmailBgmaxServiceDenied", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />
      </div>
    </div>
  );
}
